export const logo = [
  "608 134",
  `
  <title>coreui react pro</title>
`,
];
